import React, {Component} from 'react';
import { FaFacebookF, FaLinkedinIn} from "react-icons/fa";


class SocialMedia extends Component {
    render() {
        return (
            <div className="app__social">
                <div>
                    <a href="https://www.linkedin.com/in/suranga-ishara-5b785a238" target="_blank" rel="noreferrer">
                        <FaLinkedinIn/>
                    </a>
                </div>
                <div>
                    <a href="https://www.facebook.com/suranga.ishara.1/" target="_blank" rel="noreferrer">
                        <FaFacebookF/>
                    </a>
                </div>
            </div>
        );
    }
}

export default SocialMedia;